import { ruleRunner } from 'validations/ruleRunner';
import { required, minimun, ruleIfNotValue } from 'validations/rules';

const chargeTypes = { SINGLE_PAYMENT: 'N', SIGNATURE: 'A', FREE: 'G' };

const Validations = [
  ruleRunner('price', 'preço', required, minimun('5.00')),
  ruleRunner('friendly_name', 'nome exibido na fatura do cartão', ruleIfNotValue('charge_type', chargeTypes.FREE, required)),
];

export default Validations;
